import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import Icon from '../../../Icons'

const getEventHeader = (editMode, t) => ({
  buildingEvent: editMode
    ? t('create-event:formHeader.editBuildingEvent')
    : t('create-event:formHeader.createBuildingEvent'),
  class: editMode
    ? t('create-event:formHeader.editClass')
    : t('create-event:formHeader.createClass'),
  reminder: editMode
    ? t('create-event:formHeader.editReminder')
    : t('create-event:formHeader.createReminder'),
  appointment: editMode
    ? t('create-event:formHeader.editAppointment')
    : t('create-event:formHeader.createAppointment'),
})

const FormHeader = ({ editMode, handleClose, eventType }) => {
  const { t } = useTranslation(['create-event'])
  return (
    <div className="modal-header">
      <div>
        <div />
        <div>{getEventHeader(editMode, t)[eventType]}</div>
      </div>
      <div onClick={() => handleClose(false)} style={{ cursor: 'pointer' }}>
        <Icon
          icon="cross"
          styles={{ width: '20px', height: '20px', transform: 'translateY(4px)' }}
        />
      </div>
    </div>
  )
}

FormHeader.propTypes = {
  eventType: PropTypes.string,
  handleClose: PropTypes.func,
  editMode: PropTypes.bool,
}

export default FormHeader
